import styled, { css } from "styled-components";

export const StyledForm = styled.form(
  ({ theme, maxWidth }) => css`
    max-width: ${maxWidth || "auto"};
    padding: 1rem;
    border: 0.063rem solid ${theme.colors.white};
  `
);
